import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type UpdateDefaultFreightChargeMutationVariables = Types.Exact<{
  input: Types.UpdateDefaultFreightChargeInput;
}>;


export type UpdateDefaultFreightChargeMutation = { __typename?: 'Mutation', updateDefaultFreightCharge: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateOrderInvoiceReportMutationVariables = Types.Exact<{
  input: Types.UpdateOrderInvoiceReportInput;
}>;


export type UpdateOrderInvoiceReportMutation = { __typename?: 'Mutation', updateOrderInvoiceReport: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateOrderAcknowledgementReportMutationVariables = Types.Exact<{
  input: Types.UpdateOrderAcknowledgementReportInput;
}>;


export type UpdateOrderAcknowledgementReportMutation = { __typename?: 'Mutation', updateOrderAcknowledgementReport: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateOrderPullSlipReportMutationVariables = Types.Exact<{
  input: Types.UpdateOrderPullSlipReportInput;
}>;


export type UpdateOrderPullSlipReportMutation = { __typename?: 'Mutation', updateOrderPullSlipReport: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateOrderProFormaReportMutationVariables = Types.Exact<{
  input: Types.UpdateOrderProFormaReportInput;
}>;


export type UpdateOrderProFormaReportMutation = { __typename?: 'Mutation', updateOrderProFormaReport: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateDocumentRenderModeMutationVariables = Types.Exact<{
  input: Types.UpdateDocumentRenderModeInput;
}>;


export type UpdateDocumentRenderModeMutation = { __typename?: 'Mutation', updateDocumentRenderMode: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateInvoicingSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateInvoicingSettingsInput;
}>;


export type UpdateInvoicingSettingsMutation = { __typename?: 'Mutation', updateInvoicingSettings: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateStatementDeliverySettingsMutationVariables = Types.Exact<{
  input: Types.UpdateStatementDeliverySettingsInput;
}>;


export type UpdateStatementDeliverySettingsMutation = { __typename?: 'Mutation', updateStatementDeliverySettings: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTenantOrderEmailsEnabledMutationVariables = Types.Exact<{
  input: Types.UpdateOrderEmailsEnabledInput;
}>;


export type UpdateTenantOrderEmailsEnabledMutation = { __typename?: 'Mutation', updateTenantOrderEmailsEnabled: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTenantBrandingMutationVariables = Types.Exact<{
  input: Types.UpdateTenantBrandingInput;
}>;


export type UpdateTenantBrandingMutation = { __typename?: 'Mutation', updateTenantBranding: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTenantSignInPanelMutationVariables = Types.Exact<{
  input: Types.UpdateTenantSignInPanelInput;
}>;


export type UpdateTenantSignInPanelMutation = { __typename?: 'Mutation', updateTenantSignInPanel: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTenantCompanyProfileMutationVariables = Types.Exact<{
  input: Types.UpdateTenantCompanyProfileInput;
}>;


export type UpdateTenantCompanyProfileMutation = { __typename?: 'Mutation', updateTenantCompanyProfile: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTenantGradeLabelsMutationVariables = Types.Exact<{
  input: Types.UpdateTenantGradeLabelsInput;
}>;


export type UpdateTenantGradeLabelsMutation = { __typename?: 'Mutation', updateTenantGradeLabels: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTenantAutoAllocateExcludedGradesMutationVariables = Types.Exact<{
  input: Types.UpdateTenantAutoAllocateExcludedGradesInput;
}>;


export type UpdateTenantAutoAllocateExcludedGradesMutation = { __typename?: 'Mutation', updateTenantAutoAllocateExcludedGrades: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProduceEnabledMutationVariables = Types.Exact<{
  input: Types.UpdateProduceEnabledInput;
}>;


export type UpdateProduceEnabledMutation = { __typename?: 'Mutation', updateProduceEnabled: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTrackShipmentWeightMutationVariables = Types.Exact<{
  input: Types.UpdateTrackShipmentWeightInput;
}>;


export type UpdateTrackShipmentWeightMutation = { __typename?: 'Mutation', updateTrackShipmentWeight: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTenantOrderEntryUnitMutationVariables = Types.Exact<{
  input: Types.SetTenantOrderEntryUnitInput;
}>;


export type SetTenantOrderEntryUnitMutation = { __typename?: 'Mutation', setTenantOrderEntryUnit: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTenantPriceEntryUnitMutationVariables = Types.Exact<{
  input: Types.SetTenantPriceEntryUnitInput;
}>;


export type SetTenantPriceEntryUnitMutation = { __typename?: 'Mutation', setTenantPriceEntryUnit: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProduceRoundingMutationVariables = Types.Exact<{
  input: Types.UpdateProduceRoundingInput;
}>;


export type UpdateProduceRoundingMutation = { __typename?: 'Mutation', updateProduceRounding: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProducePlanningEntryUnitMutationVariables = Types.Exact<{
  input: Types.UpdateProducePlanningEntryUnitInput;
}>;


export type UpdateProducePlanningEntryUnitMutation = { __typename?: 'Mutation', updateProducePlanningEntryUnit: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProduceWeekDisplayAnchorMutationVariables = Types.Exact<{
  input: Types.UpdateProduceWeekDisplayAnchorInput;
}>;


export type UpdateProduceWeekDisplayAnchorMutation = { __typename?: 'Mutation', updateProduceWeekDisplayAnchor: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProduceSpacingDimensionUnitMutationVariables = Types.Exact<{
  input: Types.UpdateProduceSpacingDimensionUnitInput;
}>;


export type UpdateProduceSpacingDimensionUnitMutation = { __typename?: 'Mutation', updateProduceSpacingDimensionUnit: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProduceSpaceConsumptionBasisMutationVariables = Types.Exact<{
  input: Types.UpdateProduceSpaceConsumptionBasisInput;
}>;


export type UpdateProduceSpaceConsumptionBasisMutation = { __typename?: 'Mutation', updateProduceSpaceConsumptionBasis: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProduceDefaultReliefPercentMutationVariables = Types.Exact<{
  input: Types.UpdateProduceDefaultReliefPercentInput;
}>;


export type UpdateProduceDefaultReliefPercentMutation = { __typename?: 'Mutation', updateProduceDefaultReliefPercent: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProducePlanFromOrderAccessMutationVariables = Types.Exact<{
  input: Types.UpdateProducePlanFromOrderAccessInput;
}>;


export type UpdateProducePlanFromOrderAccessMutation = { __typename?: 'Mutation', updateProducePlanFromOrderAccess: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdatePricingCalcDecimalsMutationVariables = Types.Exact<{
  input: Types.UpdatePricingCalcDecimalsInput;
}>;


export type UpdatePricingCalcDecimalsMutation = { __typename?: 'Mutation', updatePricingCalcDecimals: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateBusinessTimeZoneMutationVariables = Types.Exact<{
  input: Types.UpdateBusinessTimeZoneInput;
}>;


export type UpdateBusinessTimeZoneMutation = { __typename?: 'Mutation', updateBusinessTimeZone: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTenantLoadPaperworkBindingMutationVariables = Types.Exact<{
  input: Types.SetTenantLoadPaperworkBindingInput;
}>;


export type SetTenantLoadPaperworkBindingMutation = { __typename?: 'Mutation', setTenantLoadPaperworkBinding: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTenantLoadPaperworkPolicyMutationVariables = Types.Exact<{
  input: Types.SetTenantLoadPaperworkPolicyInput;
}>;


export type SetTenantLoadPaperworkPolicyMutation = { __typename?: 'Mutation', setTenantLoadPaperworkPolicy: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateDefaultMinimumFreightChargeMutationVariables = Types.Exact<{
  input: Types.UpdateDefaultMinimumFreightChargeInput;
}>;


export type UpdateDefaultMinimumFreightChargeMutation = { __typename?: 'Mutation', updateDefaultMinimumFreightCharge: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', created: Types.TDateISO, finalCreditEnabled: boolean, isTrial: boolean, trialExpirationDate?: Types.TDateISO | null, produceEnabled: boolean, autoAllocateExcludedGrades: Array<number>, maxDiscountPercentage: number, name: string, poNumberMaxLength: number, pricingCalcDecimals: number, businessTimeZone?: string | null, tenantId: string, trackShipmentWeight: boolean, useErpPricing: boolean, defaultFreightChargeType?: Types.FreightChargeType | null, defaultMinimumFreightCharge?: number | null, defaultFreightChargeValue?: number | null, orderInvoiceReportId: string, orderAcknowledgementReportId: string, orderPullSlipReportId: string, orderProFormaReportId: string, effectiveOrderInvoiceReportId: string, effectiveOrderAcknowledgementReportId: string, effectiveOrderPullSlipReportId: string, effectiveOrderProFormaReportId: string, orderEmailsEnabled?: boolean | null, effectiveOrderEmailsEnabled: boolean, invoicingMode: Types.InvoicingMode, emailInvoiceOnIssue: boolean, statementDeliveryMethod?: Types.StatementDeliveryMethod | null, statementSkipZeroBalance?: boolean | null, organicReceiveMode: Types.OrganicReceiveMode, verifyMode: Types.VerifyMode, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit?: Types.PriceEntryUnit | null, produceRounding: Types.ProduceRoundingMode, producePlanningEntryUnit: Types.ProducePlanningEntryUnit, produceWeekDisplayAnchor: Types.ProduceWeekDisplayAnchor, produceSpacingDimensionUnit: Types.ProduceSpacingDimensionUnit, produceSpaceConsumptionBasis: Types.ProduceSpaceConsumptionBasis, produceDefaultReliefPercent: number, producePlanFromOrderAccess: Types.ProducePlanFromOrderAccess, onboardingHelpOn: boolean, onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string, gradeLabels: Array<{ __typename?: 'TenantGradeLabelData', grade: number, label: string }>, integrations: Array<{ __typename?: 'TenantIntegrationData', accessTokenExpiration: Types.TDateISO, category: Types.IntegrationCategory, created: Types.TDateISO, integrationId: string, mergeDevIntegrationName?: string | null, mergeDevIntegrationSlug?: string | null, realmId: string, source: Types.IntegrationSource }>, portalBranding?: { __typename?: 'PortalBrandingData', displayName: string, logoUrl: string, primaryColorHex: string, tagline: string, logoImage?: { __typename?: 'PortalLogoImageData', image: string, mime: string } | null, palette: { __typename?: 'PortalPaletteData', accent: string, primary: string, secondary: string, surface: string, text: string }, styleTokens: { __typename?: 'PortalStyleTokensData', button: { __typename?: 'PortalButtonData', borderRadius?: number | null, textTransform: string, variant: string }, shape: { __typename?: 'PortalShapeData', borderRadius?: number | null }, spacing: { __typename?: 'PortalSpacingData', unit?: number | null }, typography: { __typename?: 'PortalTypographyData', baseFontSize?: number | null, baseFontWeight?: number | null, fontFamily: string } } } | null, portalSignInPanel?: { __typename?: 'PortalSignInPanelData', body: string, headline: string, imageUrl: string, linkLabel: string, linkUrl: string } | null, companyProfile: { __typename?: 'TenantCompanyProfileData', name: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, email?: string | null, website?: string | null, country?: string | null }, unitConfig: { __typename?: 'TenantUnitConfigData', restockViewDisplayUnit: Types.ReplenishmentUnit }, loadPaperwork: { __typename?: 'LoadPaperworkData', bindings: Array<{ __typename?: 'LoadPaperworkBindingData', kind: Types.LoadPaperworkKind, reportId: string }>, policy?: { __typename?: 'LoadPaperworkPolicyData', regular: Array<Types.LoadPaperworkKind>, dropShip: Array<Types.LoadPaperworkKind> } | null }, documentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, effectiveDocumentRenderModes: Array<{ __typename?: 'DocumentRenderModeData', docType: Types.RenderDocType, mode: Types.RenderMode }>, onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sizeBytes: number, uploadedBy: string, occurredAt: Types.TDateISO, importedAt?: Types.TDateISO | null, reviewAreas: Array<Types.OnboardingReviewArea> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateFernieSuggestionsOnMutationVariables = Types.Exact<{
  input: Types.UpdateFernieSuggestionsOnInput;
}>;


export type UpdateFernieSuggestionsOnMutation = { __typename?: 'Mutation', updateFernieSuggestionsOn: { __typename?: 'TenantPayload', tenant?: { __typename?: 'TenantStateData', tenantId: string, fernieSuggestionsOn: boolean, fernieSuggestionsEnabled: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const UpdateDefaultFreightChargeDocument = new TypedDocumentString(`
    mutation UpdateDefaultFreightCharge($input: UpdateDefaultFreightChargeInput!) {
  updateDefaultFreightCharge(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateOrderInvoiceReportDocument = new TypedDocumentString(`
    mutation UpdateOrderInvoiceReport($input: UpdateOrderInvoiceReportInput!) {
  updateOrderInvoiceReport(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateOrderAcknowledgementReportDocument = new TypedDocumentString(`
    mutation UpdateOrderAcknowledgementReport($input: UpdateOrderAcknowledgementReportInput!) {
  updateOrderAcknowledgementReport(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateOrderPullSlipReportDocument = new TypedDocumentString(`
    mutation UpdateOrderPullSlipReport($input: UpdateOrderPullSlipReportInput!) {
  updateOrderPullSlipReport(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateOrderProFormaReportDocument = new TypedDocumentString(`
    mutation UpdateOrderProFormaReport($input: UpdateOrderProFormaReportInput!) {
  updateOrderProFormaReport(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateDocumentRenderModeDocument = new TypedDocumentString(`
    mutation UpdateDocumentRenderMode($input: UpdateDocumentRenderModeInput!) {
  updateDocumentRenderMode(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateInvoicingSettingsDocument = new TypedDocumentString(`
    mutation UpdateInvoicingSettings($input: UpdateInvoicingSettingsInput!) {
  updateInvoicingSettings(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateStatementDeliverySettingsDocument = new TypedDocumentString(`
    mutation UpdateStatementDeliverySettings($input: UpdateStatementDeliverySettingsInput!) {
  updateStatementDeliverySettings(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateTenantOrderEmailsEnabledDocument = new TypedDocumentString(`
    mutation UpdateTenantOrderEmailsEnabled($input: UpdateOrderEmailsEnabledInput!) {
  updateTenantOrderEmailsEnabled(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateTenantBrandingDocument = new TypedDocumentString(`
    mutation UpdateTenantBranding($input: UpdateTenantBrandingInput!) {
  updateTenantBranding(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateTenantSignInPanelDocument = new TypedDocumentString(`
    mutation UpdateTenantSignInPanel($input: UpdateTenantSignInPanelInput!) {
  updateTenantSignInPanel(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateTenantCompanyProfileDocument = new TypedDocumentString(`
    mutation UpdateTenantCompanyProfile($input: UpdateTenantCompanyProfileInput!) {
  updateTenantCompanyProfile(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateTenantGradeLabelsDocument = new TypedDocumentString(`
    mutation UpdateTenantGradeLabels($input: UpdateTenantGradeLabelsInput!) {
  updateTenantGradeLabels(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateTenantAutoAllocateExcludedGradesDocument = new TypedDocumentString(`
    mutation UpdateTenantAutoAllocateExcludedGrades($input: UpdateTenantAutoAllocateExcludedGradesInput!) {
  updateTenantAutoAllocateExcludedGrades(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateProduceEnabledDocument = new TypedDocumentString(`
    mutation UpdateProduceEnabled($input: UpdateProduceEnabledInput!) {
  updateProduceEnabled(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateTrackShipmentWeightDocument = new TypedDocumentString(`
    mutation UpdateTrackShipmentWeight($input: UpdateTrackShipmentWeightInput!) {
  updateTrackShipmentWeight(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const SetTenantOrderEntryUnitDocument = new TypedDocumentString(`
    mutation SetTenantOrderEntryUnit($input: SetTenantOrderEntryUnitInput!) {
  setTenantOrderEntryUnit(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const SetTenantPriceEntryUnitDocument = new TypedDocumentString(`
    mutation SetTenantPriceEntryUnit($input: SetTenantPriceEntryUnitInput!) {
  setTenantPriceEntryUnit(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateProduceRoundingDocument = new TypedDocumentString(`
    mutation UpdateProduceRounding($input: UpdateProduceRoundingInput!) {
  updateProduceRounding(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateProducePlanningEntryUnitDocument = new TypedDocumentString(`
    mutation UpdateProducePlanningEntryUnit($input: UpdateProducePlanningEntryUnitInput!) {
  updateProducePlanningEntryUnit(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateProduceWeekDisplayAnchorDocument = new TypedDocumentString(`
    mutation UpdateProduceWeekDisplayAnchor($input: UpdateProduceWeekDisplayAnchorInput!) {
  updateProduceWeekDisplayAnchor(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateProduceSpacingDimensionUnitDocument = new TypedDocumentString(`
    mutation UpdateProduceSpacingDimensionUnit($input: UpdateProduceSpacingDimensionUnitInput!) {
  updateProduceSpacingDimensionUnit(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateProduceSpaceConsumptionBasisDocument = new TypedDocumentString(`
    mutation UpdateProduceSpaceConsumptionBasis($input: UpdateProduceSpaceConsumptionBasisInput!) {
  updateProduceSpaceConsumptionBasis(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateProduceDefaultReliefPercentDocument = new TypedDocumentString(`
    mutation UpdateProduceDefaultReliefPercent($input: UpdateProduceDefaultReliefPercentInput!) {
  updateProduceDefaultReliefPercent(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateProducePlanFromOrderAccessDocument = new TypedDocumentString(`
    mutation UpdateProducePlanFromOrderAccess($input: UpdateProducePlanFromOrderAccessInput!) {
  updateProducePlanFromOrderAccess(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdatePricingCalcDecimalsDocument = new TypedDocumentString(`
    mutation UpdatePricingCalcDecimals($input: UpdatePricingCalcDecimalsInput!) {
  updatePricingCalcDecimals(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateBusinessTimeZoneDocument = new TypedDocumentString(`
    mutation UpdateBusinessTimeZone($input: UpdateBusinessTimeZoneInput!) {
  updateBusinessTimeZone(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const SetTenantLoadPaperworkBindingDocument = new TypedDocumentString(`
    mutation SetTenantLoadPaperworkBinding($input: SetTenantLoadPaperworkBindingInput!) {
  setTenantLoadPaperworkBinding(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const SetTenantLoadPaperworkPolicyDocument = new TypedDocumentString(`
    mutation SetTenantLoadPaperworkPolicy($input: SetTenantLoadPaperworkPolicyInput!) {
  setTenantLoadPaperworkPolicy(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateDefaultMinimumFreightChargeDocument = new TypedDocumentString(`
    mutation UpdateDefaultMinimumFreightCharge($input: UpdateDefaultMinimumFreightChargeInput!) {
  updateDefaultMinimumFreightCharge(input: $input) {
    tenant {
      ...TenantDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantDetails on TenantStateData {
  created
  finalCreditEnabled
  isTrial
  trialExpirationDate
  produceEnabled
  autoAllocateExcludedGrades
  gradeLabels {
    ...TenantGradeLabel
  }
  integrations {
    accessTokenExpiration
    category
    created
    integrationId
    mergeDevIntegrationName
    mergeDevIntegrationSlug
    realmId
    source
  }
  maxDiscountPercentage
  name
  poNumberMaxLength
  pricingCalcDecimals
  businessTimeZone
  portalBranding {
    displayName
    logoImage {
      image
      mime
    }
    logoUrl
    palette {
      accent
      primary
      secondary
      surface
      text
    }
    primaryColorHex
    styleTokens {
      button {
        borderRadius
        textTransform
        variant
      }
      shape {
        borderRadius
      }
      spacing {
        unit
      }
      typography {
        baseFontSize
        baseFontWeight
        fontFamily
      }
    }
    tagline
  }
  portalSignInPanel {
    body
    headline
    imageUrl
    linkLabel
    linkUrl
  }
  companyProfile {
    name
    street
    city
    state
    zip
    phone
    email
    website
    country
  }
  tenantId
  trackShipmentWeight
  unitConfig {
    restockViewDisplayUnit
  }
  loadPaperwork {
    bindings {
      kind
      reportId
    }
    policy {
      regular
      dropShip
    }
  }
  useErpPricing
  defaultFreightChargeType
  defaultMinimumFreightCharge
  defaultFreightChargeValue
  orderInvoiceReportId
  orderAcknowledgementReportId
  orderPullSlipReportId
  orderProFormaReportId
  effectiveOrderInvoiceReportId
  effectiveOrderAcknowledgementReportId
  effectiveOrderPullSlipReportId
  effectiveOrderProFormaReportId
  orderEmailsEnabled
  effectiveOrderEmailsEnabled
  documentRenderModes {
    docType
    mode
  }
  effectiveDocumentRenderModes {
    docType
    mode
  }
  invoicingMode
  emailInvoiceOnIssue
  statementDeliveryMethod
  statementSkipZeroBalance
  organicReceiveMode
  verifyMode
  orderEntryUnit
  priceEntryUnit
  produceRounding
  producePlanningEntryUnit
  produceWeekDisplayAnchor
  produceSpacingDimensionUnit
  produceSpaceConsumptionBasis
  produceDefaultReliefPercent
  producePlanFromOrderAccess
  onboardingHelpOn
  onboardingSetup
  onboardingTraining
  contractedProducts
  onboardingUploads {
    fileName
    sizeBytes
    uploadedBy
    occurredAt
    importedAt
    reviewAreas
  }
}
fragment TenantGradeLabel on TenantGradeLabelData {
  grade
  label
}`);
export const UpdateFernieSuggestionsOnDocument = new TypedDocumentString(`
    mutation UpdateFernieSuggestionsOn($input: UpdateFernieSuggestionsOnInput!) {
  updateFernieSuggestionsOn(input: $input) {
    tenant {
      ...FernieSuggestionsSetting
    }
    errors {
      code
      message
    }
  }
}
    fragment FernieSuggestionsSetting on TenantStateData {
  tenantId
  fernieSuggestionsOn
  fernieSuggestionsEnabled
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    UpdateDefaultFreightCharge: build.mutation<UpdateDefaultFreightChargeMutation, UpdateDefaultFreightChargeMutationVariables>({
      query: (variables) => ({ document: UpdateDefaultFreightChargeDocument, variables })
    }),
    UpdateOrderInvoiceReport: build.mutation<UpdateOrderInvoiceReportMutation, UpdateOrderInvoiceReportMutationVariables>({
      query: (variables) => ({ document: UpdateOrderInvoiceReportDocument, variables })
    }),
    UpdateOrderAcknowledgementReport: build.mutation<UpdateOrderAcknowledgementReportMutation, UpdateOrderAcknowledgementReportMutationVariables>({
      query: (variables) => ({ document: UpdateOrderAcknowledgementReportDocument, variables })
    }),
    UpdateOrderPullSlipReport: build.mutation<UpdateOrderPullSlipReportMutation, UpdateOrderPullSlipReportMutationVariables>({
      query: (variables) => ({ document: UpdateOrderPullSlipReportDocument, variables })
    }),
    UpdateOrderProFormaReport: build.mutation<UpdateOrderProFormaReportMutation, UpdateOrderProFormaReportMutationVariables>({
      query: (variables) => ({ document: UpdateOrderProFormaReportDocument, variables })
    }),
    UpdateDocumentRenderMode: build.mutation<UpdateDocumentRenderModeMutation, UpdateDocumentRenderModeMutationVariables>({
      query: (variables) => ({ document: UpdateDocumentRenderModeDocument, variables })
    }),
    UpdateInvoicingSettings: build.mutation<UpdateInvoicingSettingsMutation, UpdateInvoicingSettingsMutationVariables>({
      query: (variables) => ({ document: UpdateInvoicingSettingsDocument, variables })
    }),
    UpdateStatementDeliverySettings: build.mutation<UpdateStatementDeliverySettingsMutation, UpdateStatementDeliverySettingsMutationVariables>({
      query: (variables) => ({ document: UpdateStatementDeliverySettingsDocument, variables })
    }),
    UpdateTenantOrderEmailsEnabled: build.mutation<UpdateTenantOrderEmailsEnabledMutation, UpdateTenantOrderEmailsEnabledMutationVariables>({
      query: (variables) => ({ document: UpdateTenantOrderEmailsEnabledDocument, variables })
    }),
    UpdateTenantBranding: build.mutation<UpdateTenantBrandingMutation, UpdateTenantBrandingMutationVariables>({
      query: (variables) => ({ document: UpdateTenantBrandingDocument, variables })
    }),
    UpdateTenantSignInPanel: build.mutation<UpdateTenantSignInPanelMutation, UpdateTenantSignInPanelMutationVariables>({
      query: (variables) => ({ document: UpdateTenantSignInPanelDocument, variables })
    }),
    UpdateTenantCompanyProfile: build.mutation<UpdateTenantCompanyProfileMutation, UpdateTenantCompanyProfileMutationVariables>({
      query: (variables) => ({ document: UpdateTenantCompanyProfileDocument, variables })
    }),
    UpdateTenantGradeLabels: build.mutation<UpdateTenantGradeLabelsMutation, UpdateTenantGradeLabelsMutationVariables>({
      query: (variables) => ({ document: UpdateTenantGradeLabelsDocument, variables })
    }),
    UpdateTenantAutoAllocateExcludedGrades: build.mutation<UpdateTenantAutoAllocateExcludedGradesMutation, UpdateTenantAutoAllocateExcludedGradesMutationVariables>({
      query: (variables) => ({ document: UpdateTenantAutoAllocateExcludedGradesDocument, variables })
    }),
    UpdateProduceEnabled: build.mutation<UpdateProduceEnabledMutation, UpdateProduceEnabledMutationVariables>({
      query: (variables) => ({ document: UpdateProduceEnabledDocument, variables })
    }),
    UpdateTrackShipmentWeight: build.mutation<UpdateTrackShipmentWeightMutation, UpdateTrackShipmentWeightMutationVariables>({
      query: (variables) => ({ document: UpdateTrackShipmentWeightDocument, variables })
    }),
    SetTenantOrderEntryUnit: build.mutation<SetTenantOrderEntryUnitMutation, SetTenantOrderEntryUnitMutationVariables>({
      query: (variables) => ({ document: SetTenantOrderEntryUnitDocument, variables })
    }),
    SetTenantPriceEntryUnit: build.mutation<SetTenantPriceEntryUnitMutation, SetTenantPriceEntryUnitMutationVariables>({
      query: (variables) => ({ document: SetTenantPriceEntryUnitDocument, variables })
    }),
    UpdateProduceRounding: build.mutation<UpdateProduceRoundingMutation, UpdateProduceRoundingMutationVariables>({
      query: (variables) => ({ document: UpdateProduceRoundingDocument, variables })
    }),
    UpdateProducePlanningEntryUnit: build.mutation<UpdateProducePlanningEntryUnitMutation, UpdateProducePlanningEntryUnitMutationVariables>({
      query: (variables) => ({ document: UpdateProducePlanningEntryUnitDocument, variables })
    }),
    UpdateProduceWeekDisplayAnchor: build.mutation<UpdateProduceWeekDisplayAnchorMutation, UpdateProduceWeekDisplayAnchorMutationVariables>({
      query: (variables) => ({ document: UpdateProduceWeekDisplayAnchorDocument, variables })
    }),
    UpdateProduceSpacingDimensionUnit: build.mutation<UpdateProduceSpacingDimensionUnitMutation, UpdateProduceSpacingDimensionUnitMutationVariables>({
      query: (variables) => ({ document: UpdateProduceSpacingDimensionUnitDocument, variables })
    }),
    UpdateProduceSpaceConsumptionBasis: build.mutation<UpdateProduceSpaceConsumptionBasisMutation, UpdateProduceSpaceConsumptionBasisMutationVariables>({
      query: (variables) => ({ document: UpdateProduceSpaceConsumptionBasisDocument, variables })
    }),
    UpdateProduceDefaultReliefPercent: build.mutation<UpdateProduceDefaultReliefPercentMutation, UpdateProduceDefaultReliefPercentMutationVariables>({
      query: (variables) => ({ document: UpdateProduceDefaultReliefPercentDocument, variables })
    }),
    UpdateProducePlanFromOrderAccess: build.mutation<UpdateProducePlanFromOrderAccessMutation, UpdateProducePlanFromOrderAccessMutationVariables>({
      query: (variables) => ({ document: UpdateProducePlanFromOrderAccessDocument, variables })
    }),
    UpdatePricingCalcDecimals: build.mutation<UpdatePricingCalcDecimalsMutation, UpdatePricingCalcDecimalsMutationVariables>({
      query: (variables) => ({ document: UpdatePricingCalcDecimalsDocument, variables })
    }),
    UpdateBusinessTimeZone: build.mutation<UpdateBusinessTimeZoneMutation, UpdateBusinessTimeZoneMutationVariables>({
      query: (variables) => ({ document: UpdateBusinessTimeZoneDocument, variables })
    }),
    SetTenantLoadPaperworkBinding: build.mutation<SetTenantLoadPaperworkBindingMutation, SetTenantLoadPaperworkBindingMutationVariables>({
      query: (variables) => ({ document: SetTenantLoadPaperworkBindingDocument, variables })
    }),
    SetTenantLoadPaperworkPolicy: build.mutation<SetTenantLoadPaperworkPolicyMutation, SetTenantLoadPaperworkPolicyMutationVariables>({
      query: (variables) => ({ document: SetTenantLoadPaperworkPolicyDocument, variables })
    }),
    UpdateDefaultMinimumFreightCharge: build.mutation<UpdateDefaultMinimumFreightChargeMutation, UpdateDefaultMinimumFreightChargeMutationVariables>({
      query: (variables) => ({ document: UpdateDefaultMinimumFreightChargeDocument, variables })
    }),
    UpdateFernieSuggestionsOn: build.mutation<UpdateFernieSuggestionsOnMutation, UpdateFernieSuggestionsOnMutationVariables>({
      query: (variables) => ({ document: UpdateFernieSuggestionsOnDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useUpdateDefaultFreightChargeMutation, useUpdateOrderInvoiceReportMutation, useUpdateOrderAcknowledgementReportMutation, useUpdateOrderPullSlipReportMutation, useUpdateOrderProFormaReportMutation, useUpdateDocumentRenderModeMutation, useUpdateInvoicingSettingsMutation, useUpdateStatementDeliverySettingsMutation, useUpdateTenantOrderEmailsEnabledMutation, useUpdateTenantBrandingMutation, useUpdateTenantSignInPanelMutation, useUpdateTenantCompanyProfileMutation, useUpdateTenantGradeLabelsMutation, useUpdateTenantAutoAllocateExcludedGradesMutation, useUpdateProduceEnabledMutation, useUpdateTrackShipmentWeightMutation, useSetTenantOrderEntryUnitMutation, useSetTenantPriceEntryUnitMutation, useUpdateProduceRoundingMutation, useUpdateProducePlanningEntryUnitMutation, useUpdateProduceWeekDisplayAnchorMutation, useUpdateProduceSpacingDimensionUnitMutation, useUpdateProduceSpaceConsumptionBasisMutation, useUpdateProduceDefaultReliefPercentMutation, useUpdateProducePlanFromOrderAccessMutation, useUpdatePricingCalcDecimalsMutation, useUpdateBusinessTimeZoneMutation, useSetTenantLoadPaperworkBindingMutation, useSetTenantLoadPaperworkPolicyMutation, useUpdateDefaultMinimumFreightChargeMutation, useUpdateFernieSuggestionsOnMutation } = injectedRtkApi;
